import { FasIcon } from "./fas-icon.model";
import { AttachedImage } from "@/models/attached-image.model";

export class OfferElementTile {
  constructor() {
    this.id = null;
    this.index = null;
    this.image = new AttachedImage();
    this.icon_name = "fas asterisk";
    this.icon = new FasIcon(this.icon_name);
    this.title = null;
    this.short = null;
    this.visible = null;
    this.highlighted = null;
    this.large = null;
    this.created_at = null;
    this.updated_at = null;
  }
}
